import { render, staticRenderFns } from "./HeaderNew.vue?vue&type=template&id=b0cb8ff2&scoped=true&"
import script from "./HeaderNew.vue?vue&type=script&lang=js&"
export * from "./HeaderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cb8ff2",
  null
  
)

export default component.exports